<template>
  <div class="selectcar">
    <div @click="triggerClick">
      <el-button v-if="!$slots.default" type="primary">选择充电桩</el-button>
      <slot></slot>
    </div>
    <Dialog :title="title" :padding="0" v-model="dialogVisible" @confirm="confirm">
      <div class="flex-stretch" v-loading="loading">
        <section class="select-section section-left">
          <div class="flex-center mb20">
            <div class="title-border"></div>
            <div class="title-text">选择</div>
          </div>
          <div class="mb20">
            <el-autocomplete v-model="searchValue" style="width: 100%;" :fetch-suggestions="querySearch" placeholder="搜索"
              prefix-icon="el-icon-search" :trigger-on-focus="false" clearable @select="searchSelect">
              <div class="flex-center pt5 pb5" slot-scope="{ item }">
                <img class="car-icon" :src="item.picPath || carImg" alt="">
                <span class="over-omit" style="max-width: 180px;">{{ item.label }}</span>
              </div>
            </el-autocomplete>
          </div>
          <div class="mb30" v-show="limit > 1">
            <el-checkbox v-model="checkAll" @change="checkAllChange">全选</el-checkbox>
          </div>
          <div v-show="treeData.length > 0">
            <el-tree :data="treeData" class="trees" ref="tree" node-key="treekey" show-checkbox
              :default-checked-keys="defaultCheckedKeys" @check-change="checkChange">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <div class="flex-center-side">
                  <div class="flex-center">
                    <img class="car-icon" :src="data.picPath || carImg" alt="">
                    <div class="flex-center">
                      <span class="over-omit" style="max-width: 180px;">{{ node.label }}</span>
                    </div>
                  </div>
                </div>
              </span>
            </el-tree>
          </div>
          <div v-show="treeData.length === 0 && !loading">
            <div class="emtyimg-box">
              <el-image :src="emtyImg"></el-image>
              <div>暂无数据</div>
            </div>
          </div>
        </section>
        <section class="select-section section-right">
          <div class="flex-center mb20">
            <div class="title-border"></div>
            <div class="title-text">已选</div>
          </div>
          <div class="result">
            <div class="flex-center-side result-item" v-for="(item, index) in result" :key="index">
              <div class="flex-center">
                <img class="car-icon" :src="item.picPath || carImg" alt="">
                <span>{{ item.label }}</span>
              </div>
              <div class="del-icon text-red-500 hover:opacity-70" @click="resDel(item, index)">
                <i class="el-icon-close"></i>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Dialog>
  </div>
</template>

<script>
import lodash from 'lodash';
import { queryCarChargeList } from '@/api/select';
import emtyImg from '@imgs/empty.png';
import carImg from '@imgs/cur_carhead_default@3x.png';

/**
 * 选择车
 */

export default {
  name: 'SelectCar',
  model: {
    prop: 'value',
    event: 'confirm'
  },
  props: {
    // 选中的充电桩数据
    value: {
      type: Array,
      default: () => []
    },
    // 传入列表数据，默认从接口获取
    tree: {
      type: [Array, String],
      default: ''
    },
    // 弹窗标题
    title: {
      type: String,
      default: '选择充电桩'
    },
    // 单位id，默认不传，查所有单位所有充电桩；传入teamId，查询指定单位的充电桩
    teamId: {
      type: [Number, String],
      default: ''
    },
    // 可选数量限制，设置为1表示单选，默认是多选
    limit: {
      type: Number,
      default: 10000
    },
    // 点击触发栏之前的操作，返回false，可阻止打开弹层
    beforeTrigger: Function,
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      checkAll: false,
      searchValue: '',
      emtyImg,
      carImg,
      result: [], // 已选
      searchTimer: null,
      treeData: [], // 树
    };
  },
  watch: {
    result: {
      handler() {
        const arr = this.treeData.filter(ele => ele.treekey);
        this.checkAll = arr.length > 0 && arr.every(ele => this.result.some(r => r.treekey === ele.treekey));
      },
      deep: true
    },
    treeData: {
      handler() {
        const arr = this.treeData.filter(ele => ele.treekey);
        this.checkAll = arr.length > 0 && arr.every(ele => this.result.some(r => r.treekey === ele.treekey));
      },
      deep: true
    },
  },
  computed: {
    defaultCheckedKeys() {
      return this.value.map(ele => ele.keyId)
    },
  },
  methods: {
    /**
     * 点击触发栏
     */
    triggerClick() {
      if (this.beforeTrigger && this.beforeTrigger() === false) return;
      this.reset();
      this.setDefault();
      this.getDatas();
      this.dialogVisible = !this.dialogVisible;
    },
    /**
     * 搜索
     */
    querySearch(text, cb) {
      let list = [];
      if (!text) {
        cb(list);
        return false;
      }
      // 防抖
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.searchTimer = setTimeout(() => {
        this.treeData.forEach(item => {
          if (item.label.includes(text)) {
            list.push(item);
          }
        });
        cb(list);
      }, 500);
    },
    /**
     * 选择搜索结果
     */
    searchSelect(val) {
      const checked = this.result.findIndex(ele => ele.treekey === val.treekey) > -1;
      if (checked) return;
      this.searchValue = val.chargeName;
      if (this.limit === 1) {
        // 单选
        this.result = [{ ...val }];
        this.$refs.tree.setCheckedKeys([val.treekey], true);
      } else {
        this.result.push(val);
        const treekeys = this.result.map(ele => ele.treekey);
        this.$refs.tree.setCheckedKeys(treekeys, true);
      }
    },
    /**
     * 重置
     */
    reset() {
      this.result = [];
      this.checkAll = false;
      this.searchValue = '';
    },
    /**
     * 设置默认勾选项
     */
    setDefault() {
      this.result = this.value.map(ele => {
        return {
          ...ele,
          type: 'car',
          label: ele.chargeName,
          treekey: ele.keyId
        };
      });
      this.$nextTick(() => {
        const keys = this.result.map(ele => ele.treekey);
        if (this.$refs.tree) {
          this.$refs.tree.setCheckedKeys(keys);
        }
      });
    },
    /**
     * 确定
     */
    confirm() {
      const clone = lodash.cloneDeep(this.result);
      this.$emit('confirm', clone);
      this.dialogVisible = false;
    },
    /**
     * 全选
     */
    checkAllChange(checked) {
      this.treeData.forEach(item => {
        const index = this.result.findIndex(ele => ele.treekey === item.treekey);
        if (index === -1 && checked) {
          this.result.push(item);
        } else if (index > -1 && !checked) {
          this.result.splice(index, 1);
        }
      });
      this.$nextTick(() => {
        const keys = this.result.map(ele => ele.treekey);
        this.$refs.tree.setCheckedKeys(keys);
      });
    },
    /**
     * 删除已选
     */
    resDel(val, index) {
      this.result.splice(index, 1);
      this.$refs.tree.setChecked(val.treekey, false);
    },
    /**
     * 勾选
     */
    checkChange(data, checked) {
      data.checked = checked;
      const index = this.result.findIndex(ele => ele.treekey === data.treekey);
      if (checked && index === -1) {
        if (this.limit === 1) {
          // 单选
          this.result = [{ ...data }];
          this.$refs.tree.setCheckedKeys([data.treekey], true);
        } else {
          this.result.push(data);
        }
      } else if (!checked && index > -1) {
        this.result.splice(index, 1);
      }
    },
    /**
     * 获取数据
     */
    getDatas() {
      this.loading = true;
      if (this.tree) {
        this.treeData = this.tree.map(item => {
          // 充电桩数据
          return {
            ...item,
            label: item.chargeName,
            treekey: item.keyId,
          }
        });
        this.loading = false;
        return;
      }
      const params = {
        teamId: this.teamId,
        exportType: 1
      };
      queryCarChargeList(params).then((res) => {
        this.treeData = (res.lst || []).map(ele => {
          return {
            ...ele,
            label: ele.chargeName,
            treekey: ele.keyId
          }
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// 超出一行显示省略号
.over-omit {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.crumb-box {
  overflow: hidden;
  position: relative;
}

.crumb-back {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  height: 100%;
  width: 80px;
  color: #333;
  cursor: pointer;
  background: linear-gradient(to left, transparent, #fff 30%);
}

.crumb-over {
  justify-content: flex-end;
}

.crumb {
  white-space: nowrap;
  width: fit-content;
}

.crumb-item {
  color: #333;
  cursor: pointer;
}

.crumb-last {
  color: #888;
  cursor: auto;
}

.result {
  .result-item {
    +.result-item {
      margin-top: 20px;
    }
  }
}

.del-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;

  &:hover {
    opacity: .8;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.car-icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
}

.dpt-icon {
  width: 20px;
  height: 18px;
  object-fit: cover;
  margin-right: 10px;
}

::v-deep .el-checkbox {
  .el-checkbox__input {
    margin-right: 10px;

    .el-checkbox__inner {
      width: 20px;
      height: 20px;
    }
  }

  .is-checked {
    .el-checkbox__inner {

      // background-color: unset;
      &::after {
        // border: 2px solid #3642FF;
        left: 7px;
        top: 4px;
      }
    }
  }
}

.trees {
  ::v-deep .el-checkbox {
    & .is-disabled {
      visibility: hidden;
      // display: none;
    }
  }
}

::v-deep .el-tree {
  .el-tree-node {
    +.el-tree-node {
      margin-top: 20px;
    }
  }
}

::v-deep .el-tree-node__expand-icon {
  display: none;
}

.custom-tree-node {
  display: block;
  width: 100%;

  ::v-deep .el-button {
    min-width: unset;
  }
}

.title-border {
  width: 3px;
  height: 12px;
  background-color: #333;
  margin-right: 5px;
}

.title-text {
  color: #333;
  font-size: 14px;
  font-weight: bold;
}

.select-section {
  width: 50%;
  height: calc(90vh - 170px);
  overflow-y: auto;
  box-sizing: border-box;
  padding: 30px;
}

.mr5 {
  margin-right: 5px;
}

.mb20 {
  margin-bottom: 20px;
}

.mb30 {
  margin-bottom: 30px;
}

.mt10 {
  margin-top: 10px;
}

.pt5 {
  padding-top: 5px;
}

.pb5 {
  padding-bottom: 5px;
}

// flex布局
.flex {
  display: flex;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-column {
  @extend .flex;
  flex-direction: column;
}

.flex-column-center {
  @extend .flex-column;
  align-items: center;
}

.flex-center {
  @extend .flex;
  align-items: center;
}

.flex-stretch {
  @extend .flex;
  align-items: stretch;
}

.flex-line {
  @extend .flex;
  align-items: baseline;
}

.flex-center-center {
  @extend .flex-center;
  justify-content: center;
}

.flex-center-side {
  @extend .flex-center;
  justify-content: space-between;
}

.flex-stretch-center {
  @extend .flex-stretch;
  justify-content: center;
}

.flex-stretch-side {
  @extend .flex-stretch;
  justify-content: space-between;
}

.emtyimg-box {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin-top: 130px;

  ::v-deep .el-image {
    width: 160px;
  }
}
</style>
